module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAALVBMVEUAAAAADCQAESIAECgHECcGECoDDycGEioGECoGESoFECoFECkFESkFESoGESrEjSYcAAAADnRSTlMAFR4gTk9UVqrn6erx8gMhIZAAAABHSURBVCjPY2CgCmCZ9w4KXjqABTjfwcEEsADfAwgCQWSBx3poAm/PoQm8e4cmsKwaVYBDgLEBRQDKGvYCGIHMioiGAOpELABRrmoQCXGUIwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_zhuanye.png
// module id = Iro/
// module chunks = 52